// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__KHwEV","item":"PaymentsMobile_item__38xE7","label":"PaymentsMobile_label__1n2E9","amount":"PaymentsMobile_amount__HJk3t"};